import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import {catchError, concatMap, map, switchMap, withLatestFrom} from 'rxjs/operators';
import {EMPTY, Observable, of} from 'rxjs';
import * as featureActions from '../../index';
import {Action, Store} from '@ngrx/store';
import * as fromStore from '../../../store';
import {RegionService} from '../../../services/region.service';
import {UpdateInfoModel} from '../../updateInfo/update-info.model';
import {updateInfoType} from '../../../shareModel';

@Injectable()
export class RegionEffects {
  private actions$ = inject(Actions);
  private store$ = inject(Store<fromStore.State>);
  private regionService = inject(RegionService);

  constructor() {}


  readRegion$ = createEffect(() => this.actions$.pipe(
    ofType<featureActions.GetRegions>(featureActions.RegionActionTypes.GetRegions),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]) => {
      return this.regionService.ReadRegion(user.otp).pipe(
        map((res: any) => {
          if (res.result) {
            return new featureActions.LoadRegions(res.msg.body);
          } else {
            return { type: '[Region] Load Regions Silent Fail' }; 
          }
        }),
        catchError(() => EMPTY)
      );
    })
  ));

  updateRegion$ = createEffect(() => this.actions$.pipe(
    ofType<featureActions.UpdateRegions>(featureActions.RegionActionTypes.UpdateRegions),
    map((action: featureActions.UpdateRegions) => action.payload),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([payload, user]) => {
      // NgRx 9 不可變性: 創建新對象副本
      const params = {
        ...payload.changes,
        otp: user.otp,
        Id: Number(payload.id)
      };
      return this.regionService.UpdateRegion(params).pipe(
        switchMap((res: UpdateInfoModel) => {
          const result = { ...res, type: updateInfoType.EditRegion };
          if (result.result) {
            return [new featureActions.GetRegions(), new featureActions.UpdateInfoSuccessAction(result)];
          } else {
            return [new featureActions.UpdateInfoFailAction(result)];
          }
        }),
        // TODO: catchError Message調整 --> 已完成
        catchError(error => {
          const res: UpdateInfoModel = {
            result: false,
            errmsg: 'Error',
            type: updateInfoType.EditRegion
          };
          return [new featureActions.UpdateInfoFailAction(res)];
        })
      );
    })
  ));

  addRegion$ = createEffect(() => this.actions$.pipe(
    ofType<featureActions.AddRegions>(featureActions.RegionActionTypes.AddRegions),
    map((action: featureActions.AddRegions) => action.payload),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([payload, user]) => {
      // NgRx 9 不可變性: 創建新對象副本
      const params = { ...payload, otp: user.otp };
      return this.regionService.AddRegion(params).pipe(
        switchMap((res: UpdateInfoModel) => {
          const result = { ...res, type: updateInfoType.AddRegion };
          if (result.result) {
            return [new featureActions.GetRegions(), new featureActions.UpdateInfoSuccessAction(result)];
          } else {
            return [new featureActions.UpdateInfoFailAction(result)];
          }
        }),
        // TODO: catchError Message調整 --> 已完成
        catchError(error => {
          const res: UpdateInfoModel = {
            result: false,
            errmsg: 'Error',
            type: updateInfoType.AddRegion
          };
          return [new featureActions.UpdateInfoFailAction(res)];
        })
      );
    })
  ));

  deleteRegion$ = createEffect(() => this.actions$.pipe(
    ofType<featureActions.DeleteRegions>(featureActions.RegionActionTypes.DeleteRegions),
    map((action: featureActions.DeleteRegions) => action.payload),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([payload, user]) => {
      const params = { ...payload, otp: user.otp };
      return this.regionService.DeleteRegion(params).pipe(
        switchMap((res: UpdateInfoModel) => {
          const result = { ...res, type: updateInfoType.DeleteRegion };
          if (result.result) {
            return [new featureActions.GetRegions(), new featureActions.UpdateInfoSuccessAction(result)];
          } else {
            console.log('error');
            return [new featureActions.UpdateInfoFailAction(result)];
          }
        }),
        // TODO: catchError Message調整 --> 已完成
        catchError(error => {
          const res: UpdateInfoModel = {
            result: false,
            errmsg: 'Error',
            type: updateInfoType.DeleteRegion
          };
          return [new featureActions.UpdateInfoFailAction(res)];
        })
      );
    })
  ));

}